import { useQuery } from 'react-query';
import { getBettieInfo, type GetBettieInfoResponse } from '../../services/bettieService';

export function useGetBettieInfo(bettieId: string) {
  return useQuery<GetBettieInfoResponse>(['bettieInfo', bettieId], () => getBettieInfo(bettieId), {
    enabled: !!bettieId
  });
}
